import React from 'react';
// eslint-disable-next-line no-unused-vars -- used in JSX
import ProposalImage from './ProposalImage';
import plantImage from '../assets/proposalImages/plant_black.jpg';


export default function QuotationCoverPage({ company = {}, metadata = {} }) {
  const name = company.name || 'VALUE ADDED COATING SOLUTION PVT. LTD.';
  const shortName = name.split(' ').slice(0, 4).join(' ');

  return (
    <div className="a4-paddings quotation-page quotation-cover-gradient quotation-cover-a4">
      <div className="quotation-accent" style={{ top: -80, right: -80, width: 320, height: 320, borderRadius: '50%' }} />
      <div className="quotation-accent" style={{ bottom: -120, left: -80, width: 260, height: 260, borderRadius: '50%' }} />

      <div className="quotation-cover-header">
        <div className="quotation-cover-logo">
          <span style={{ fontSize: 18, fontWeight: 800, lineHeight: 1 }}>⚙</span>
        </div>
      </div>

      <div className="quotation-cover-center">
        <p className="quotation-cover-label">TECHNO-COMMERCIAL PROPOSAL</p>
        <h1 className="quotation-cover-title">PROPOSAL</h1>
        <p className="quotation-cover-subtitle">Industrial Coating Solutions</p>
        <div className="quotation-cover-divider" />
        <p className="quotation-cover-subject">
          {metadata.subject || 'Premium Coating & Surface Treatment Systems'}
        </p>
      </div>
      
        <ProposalImage
          src={plantImage}
          wrapperStyle={{ marginTop: 12, marginBottom: 20, padding: 10 }}
          imgStyle={{ borderRadius: 6 }}
        />

      <div className="quotation-cover-footer">
        <div className="quotation-cover-footer-grid">
          <div>
            <p className="quotation-cover-footer-label">Prepared By</p>
            <p className="quotation-cover-footer-value">{shortName}</p>
            <p className="quotation-cover-footer-meta">Private Limited</p>
          </div>
          <div style={{ textAlign: 'right' }}>
            <p className="quotation-cover-footer-label">Reference</p>
            <p className="quotation-cover-footer-value">
              {metadata.reference || 'As per discussion'}
            </p>
            <p className="quotation-cover-footer-meta">
              {new Date().toLocaleDateString('en-IN', { day: 'numeric', month: 'long', year: 'numeric' })}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
